import React from "react";
import PropTypes from "prop-types";

// import hoc
import { withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";

import { FormCreate } from "app/vendors/modules/generic/feature/add/subFeatures";

const AdminFormCreate = (props) => {
  const {
    // learnMore
    setBanner,
  } = props;
  // return <FormCreate setBanner={setBanner} learnMore={learnMore} />;
  return <FormCreate setBanner={setBanner} />;
};

AdminFormCreate.propTypes = {
  setBanner: PropTypes.func.isRequired,
  // learnMore: PropTypes.func.isRequired,
};

export default withFeature(AdminFormCreate, { feature: constant.FORM_CREATE });
